import { PER_PAGE_10 } from '@/common/constants';
import { graphqlRequest } from '../urql';
import {
  getDigitalThemesQuery,
  getPrintThemesQuery,
  getThemeDefaultQuery,
  getDigitalThemeByIdQuery,
  getPrintThemeByIdQuery
} from './queries';
import { isOk } from '@/common/utils';
import { get } from 'lodash';

const getPrintThemeApi = async (page, hideSpiner) => {
  const res = await graphqlRequest(
    getPrintThemesQuery,
    { page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  if (!isOk(res)) return [];

  const pairs = get(res, 'data.template_book_pairs');
  return pairs.map(item => ({
    id: item.id,
    name: item.template_book?.name || item.spread_template_book?.name || '',
    value: item.id,
    previewImageUrl: item.preview_image_url
  }));
};

const getDigitalThemeApi = async (page, hideSpiner) => {
  const res = await graphqlRequest(
    getDigitalThemesQuery,
    { page, perPages: PER_PAGE_10 },
    hideSpiner
  );

  if (!isOk(res)) return [];

  const themes = get(res, 'data.themes');

  return themes.map(item => ({
    id: item.id,
    name: item.name,
    value: item.id,
    previewImageUrl: item.digital_preview_image_url
  }));
};

/**
 * Get list of theme
 *
 * @returns {Promise<Array>} theme list
 */
export const getThemesApi = async (isDigital, page, hideSpiner) => {
  return isDigital
    ? getDigitalThemeApi(page, hideSpiner)
    : getPrintThemeApi(page, hideSpiner);
};

export const getDefaultThemeApi = async bookId => {
  const res = await graphqlRequest(getThemeDefaultQuery, { bookId });

  if (!isOk(res)) return {};

  const printDefaultTheme = get(res, 'data.book.print_theme_id');
  const digitalDefaultTheme = get(res, 'data.book.digital_theme_id');

  return {
    printDefaultTheme,
    digitalDefaultTheme
  };
};

export const getThemeByIdApi = async (themeId, isDigital = false) => {
  return isDigital
    ? getDigitalThemeByIdApi(themeId)
    : getPrintThemeByIdApi(themeId);
};

const getDigitalThemeByIdApi = async themeId => {
  const res = await graphqlRequest(getDigitalThemeByIdQuery, { themeId });
  const theme = get(res, 'data.theme');
  if (!theme) return {};
  return {
    id: theme.id,
    name: theme.name,
    value: theme.id,
    previewImageUrl: theme.digital_preview_image_url
  };
};

const getPrintThemeByIdApi = async themeId => {
  const res = await graphqlRequest(getPrintThemeByIdQuery, { themeId });
  const pair = get(res, 'data.template_book_pair');
  if (!pair) return {};
  return {
    id: pair.id,
    name: pair.template_book?.name || pair.spread_template_book?.name || '',
    value: pair.id,
    previewImageUrl: pair.preview_image_url
  };
};
